import { Checkbox, FormControlLabel } from '@mui/material';
import { SCHEDULER_LABEL_CLASS } from '../CustomTableViews/schedulerFieldClasses';
import { WorkflowTab } from '../../../Api/Orders/ordersApi';
import { WORKFLOW_TAB_LABELS, WORKFLOW_TAB_ORDER } from '../../Pages/Orders/workflowTabs';

export interface IncludedTabsFieldProps {
  value: WorkflowTab[];
  disabled: boolean;
  onChange: (tabs: WorkflowTab[]) => void;
}

/** The Orders workflow tabs whose orders a report sends, kept in the page's tab order. */
export const IncludedTabsField = ({ value, disabled, onChange }: IncludedTabsFieldProps) => {
  const toggle = (tab: WorkflowTab, checked: boolean) =>
    onChange(WORKFLOW_TAB_ORDER.filter((t) => (t === tab ? checked : value.includes(t))));

  return (
    <fieldset className="mb-3">
      <legend className={SCHEDULER_LABEL_CLASS}>Include data from</legend>
      <div className="flex flex-col items-start">
        {WORKFLOW_TAB_ORDER.map((tab) => (
          <FormControlLabel
            key={tab}
            sx={{ ml: 0, '& .MuiFormControlLabel-label': { fontSize: '0.875rem' } }}
            control={
              <Checkbox
                size="small"
                sx={{ p: 0.5 }}
                checked={value.includes(tab)}
                disabled={disabled}
                onChange={(e) => toggle(tab, e.target.checked)}
              />
            }
            label={WORKFLOW_TAB_LABELS[tab]}
          />
        ))}
      </div>
    </fieldset>
  );
};
